import { render, staticRenderFns } from "./CampaignWizardTitle.vue?vue&type=template&id=dc748dbc&scoped=true"
import script from "./CampaignWizardTitle.vue?vue&type=script&lang=ts"
export * from "./CampaignWizardTitle.vue?vue&type=script&lang=ts"
import style0 from "./CampaignWizardTitle.vue?vue&type=style&index=0&id=dc748dbc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc748dbc",
  null
  
)

export default component.exports